import React from "react";
import {
  getSlugs,
  getCaseDbData,
  getContent,
} from "helpers/case-helpers";
import serializeJsonForStaticProps from "helpers/serializeJsonForStaticProps";

import CasePage from "components/CasePage";


export async function getStaticPaths() {
  
  const slugApiParams = (process.env.CONTEXT === "production") ? {
    limit: 100,
  } : {
    limit: 10,
  };
  
  const resp = await getSlugs(slugApiParams);

  return {
    paths: resp?.result?.map((c) => ({
      params: { slug: c },
    })),
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params, preview = false }) {
  if (!params) throw new Error();
  const { slug } = params;
  if (!slug || Array.isArray(slug)) throw new Error();

  // Get props for case page
  const [{ result: caseData }, contentQuery] = await Promise.all([
    getCaseDbData(slug),
    getContent(slug, { preview }),
  ]);

  if (!caseData) return { notFound: true };

  const events = caseData.events || null;
  const images = caseData.images || null;
  const locations = caseData.locations || null;
  // Workaround for the SSR issue with array order
  const personsList = caseData.persons || null;
  const personVictim = personsList.length > 0 ? personsList[0] : null;
  const featuredSource =
    caseData.sources.find((source) => source.featured) || null;
  const uncovereds = caseData.resources;
  const sources = caseData.sources;

  // sort events by order
  const orderedEventsRecords = events?.sort((a, b) => {
    const aOrder = a.order;
    const bOrder = b.order;
    return aOrder - bOrder;
  });

  const sourcesList = caseData.sources ?? [];

  // Only Online Sources
  const sourceOnlineResources = sourcesList.filter(
    (record) =>
      record.classification && record.classification.includes("Online Source")
  );

  // Only Podcasts
  const sourcePodcasts = sourcesList.filter(
    (record) =>
      record.classification && record.classification.includes("Podcast")
  );

  // Combine the two above for a filter
  const sourceOnlineAndPodcasts = sourceOnlineResources.concat(sourcePodcasts);

  // All the non Online Sources and Podcasts
  const sourceMiscRecords = sourcesList.filter(function (record) {
    return !sourceOnlineAndPodcasts.includes(record);
  });

  return {
    props: {
      preview,
      casePageProps: {
        caseData,
        // events,
        orderedEventsRecords,
        featuredSource,
        images,
        locations,
        personsList,
        personVictim,
        sources,
        uncovereds,
        slug,
        contentQuery: serializeJsonForStaticProps(contentQuery),
        preview,
        sourceOnlineResources,
        sourcePodcasts,
        sourceMiscRecords,
      },
    },
    revalidate: 60 * 30,
  };
}

export default function Case({ casePageProps }) {
  return <CasePage {...casePageProps} />;
}
